/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AppRouteRouteImport } from './routes/app/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppChatRouteRouteImport } from './routes/app/chat/route'
import { Route as AppChatIndexRouteImport } from './routes/app/chat/index'
import { Route as AppChatConversationIdRouteImport } from './routes/app/chat/$conversationId'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppChatRouteRoute = AppChatRouteRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppChatIndexRoute = AppChatIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppChatRouteRoute,
} as any)
const AppChatConversationIdRoute = AppChatConversationIdRouteImport.update({
  id: '/$conversationId',
  path: '/$conversationId',
  getParentRoute: () => AppChatRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/app/chat': typeof AppChatRouteRouteWithChildren
  '/app/': typeof AppIndexRoute
  '/app/chat/$conversationId': typeof AppChatConversationIdRoute
  '/app/chat/': typeof AppChatIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/app': typeof AppIndexRoute
  '/app/chat/$conversationId': typeof AppChatConversationIdRoute
  '/app/chat': typeof AppChatIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/app/chat': typeof AppChatRouteRouteWithChildren
  '/app/': typeof AppIndexRoute
  '/app/chat/$conversationId': typeof AppChatConversationIdRoute
  '/app/chat/': typeof AppChatIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/app/chat'
    | '/app/'
    | '/app/chat/$conversationId'
    | '/app/chat/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/app'
    | '/app/chat/$conversationId'
    | '/app/chat'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/app/chat'
    | '/app/'
    | '/app/chat/$conversationId'
    | '/app/chat/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/chat': {
      id: '/app/chat'
      path: '/chat'
      fullPath: '/app/chat'
      preLoaderRoute: typeof AppChatRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/chat/': {
      id: '/app/chat/'
      path: '/'
      fullPath: '/app/chat/'
      preLoaderRoute: typeof AppChatIndexRouteImport
      parentRoute: typeof AppChatRouteRoute
    }
    '/app/chat/$conversationId': {
      id: '/app/chat/$conversationId'
      path: '/$conversationId'
      fullPath: '/app/chat/$conversationId'
      preLoaderRoute: typeof AppChatConversationIdRouteImport
      parentRoute: typeof AppChatRouteRoute
    }
  }
}

interface AppChatRouteRouteChildren {
  AppChatConversationIdRoute: typeof AppChatConversationIdRoute
  AppChatIndexRoute: typeof AppChatIndexRoute
}

const AppChatRouteRouteChildren: AppChatRouteRouteChildren = {
  AppChatConversationIdRoute: AppChatConversationIdRoute,
  AppChatIndexRoute: AppChatIndexRoute,
}

const AppChatRouteRouteWithChildren = AppChatRouteRoute._addFileChildren(
  AppChatRouteRouteChildren,
)

interface AppRouteRouteChildren {
  AppChatRouteRoute: typeof AppChatRouteRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppChatRouteRoute: AppChatRouteRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
